// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--T0UgJxkkPrIkuOug","listWrapper":"list-wrapper--oYuHYJAGLKAkzDY2"};